import { MenuLocationEnum } from "utils";
import { WpMenu } from "codegen";
import { graphql, useStaticQuery } from "gatsby";

interface useAllMenusInterface {
  locationName?: keyof typeof MenuLocationEnum;
}

/**
 * Retrieve all WordPress menus via useStaticQuery hook. If a locationName is passed, return menu specific to that location.
 * @param {('ABOVE_PRIMARY_NAVIGATION' | 'FOOTER_NAVIGATION' | 'LEGAL_NAVIGATION' | 'PRIMARY_NAVIGATION')} locationName - Location for the menu
 * @returns Filtered menu based of passed locationName prop, otherwise returns all menus.
 */

export const useAllMenus = (locationName: useAllMenusInterface): WpMenu => {
  const { allWpMenu } = useStaticQuery(
    graphql`
      {
        allWpMenu {
          nodes {
            locations
            name
            slug
            databaseId
            menuItems {
              nodes {
                cssClasses
                url
                title
                target
                path
                order
                label
                id
                parentDatabaseId
                parentId
                childItems {
                  nodes {
                    cssClasses
                    url
                    title
                    target
                    path
                    order
                    label
                    id
                    parentDatabaseId
                    parentId
                    linkRelationship
                    childItems {
                      nodes {
                        cssClasses
                        url
                        title
                        target
                        path
                        order
                        label
                        id
                        parentDatabaseId
                        parentId
                        linkRelationship
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
  );
  const menus = allWpMenu.nodes;
  const filteredMenu = menus.filter((node) => node?.locations?.includes(locationName)).pop();

  return filteredMenu || allWpMenu?.nodes;
};
